var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 7.73344L10 9.45198V11.1705H5.83333V16.3262L5 17.1854L4.16667 16.3262V11.1705H0V9.45198L1.66667 7.73344V1.71854H0.833333V0H9.16667V1.71854H8.33333V7.73344ZM2.375 9.45198H7.625L6.66667 8.46382V1.71854H3.33333V8.46382L2.375 9.45198Z",
    fill: "#0A8BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeep);
export default __webpack_public_path__ + "static/media/keep.fa263772a196c0aafb970a18922ba65e.svg";
export { ForwardRef as ReactComponent };